<template>

	<div v-if="id" class="container">
		<div class="media">
			<img class="mr-3" :src="worker.picture">
			<div class="media-body">
				<h5 class="mt-0">{{ worker.first_name }} {{worker.last_name}}</h5>
				<h6 class="p-1 mt-0 mb-0">{{worker_types[worker.type].label}} - {{$config.job_types[worker.job].label}}</h6>
				<h6 class="p-1 mb-1"  :style="{backgroundColor: worker.company.bg_color, color: companyTextColor(worker)}">{{ worker.company.title }}</h6>
				<dl>
					<dd>Efficiency rating: {{worker.efficiency}}</dd>
					<dd>Safety rating: {{worker.safety}}</dd>
					<dd>{{worker.zone.name}}</dd>
					<!--<dd>{{ worker.status }} - {{worker.id}}</dd>-->
				</dl>

				<select v-if="debug" @change="setWorkerDestination($event)" :value="worker.target_zone_id" >
					<option  v-for="zone in zones" :key="zone.id" :value="zone.id">{{zone.name}}</option>
				</select>

			</div>
		</div>

		<div class="mt-3">
			<h5>Events</h5>

			<div v-for="day_events in watcher" :key='day_events.id'>

				<div v-for="event in day_events[id]" v-if="event.report != 'no'" class="alert"  v-bind:class="'alert-' + event.class_type" :key='event.id'>
					Asset {{ event.label }} "{{ event.type == 'travel' ? $zone.get(event.target_zone_id).name : $zone.get(event.zone_id).name }}" at {{ event.clock}}
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import * as tinycolor from 'tinycolor2';
	import {mapState} from "vuex";
	export default {
		name: 'ProfilePanel',
		data() {
			return {
				id: null,
				rec: null,
				worker: null,
			}
		},
		computed: {
			...mapState([
				"workers",
				"vehicles",
				"clock",
				"time",
				"day",
				"muster",
				"sprites",
				"watcher",
				"move_watcher",
				"worker_status",
				"zones",
				"proximity"
			]),
			worker_types() { return this.$config.worker_types },
			drawLayer() { return this.$store.state.map.drawLayer },
			zones() { return this.$store.state.zones},
			map() { return this.$store.state.map.map },
			alert: {
				get() { return this.$store.state.alert },
				set(value) {
					this.$store.commit('add_alert', value)
				}
			},
			muster() { return this.$store.state.muster},
			debug: {
				get() { return this.$store.state.debug },
				set(value) { this.$store.commit('setState', ['debug', value]) }
			},
		},
		watch: {
			id() {
				if (this.id) {
					this.worker = this.workers[this.id];
				}
				else this.worker = {};
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {

				this.map.on('click', (e) => {
					var features = this.map.getFeaturesAtPixel(e.pixel);
					if (features == undefined) return;

					for (var i in features) {
						var feature = features[i];
						if (feature.type == 'worker') {
							this.$URL.set({'asset-log': feature.id});
							if (this.debug) {
								console.log(this.workers[feature.id]);

								// console.log(this.watcher[feature.id]);
								// console.log(this.worker_status[feature.id]);
							}
						}
						else if (this.$asset.isVehicle(feature)) {
							if (this.debug) console.log(this.vehicles[feature.id])
						}
					}

				});

				this.id = this.$URL.get('asset-log');
				this.debug = this.$URL.get('debug');
				window.addEventListener('hashchange', () => {
					this.id = this.$URL.get('asset-log');
					this.debug = this.$URL.get('debug');
				});

			},
			companyTextColor(worker) {
				return tinycolor(worker.company.bg_color).isLight() ? '#000' : '#fff'
			},
			setWorkerDestination($event) {
				this.worker.target_zone_id = $event.target.value;
			}
		}
	}
</script>
